import { colors } from 'styles/tokens'

/**
 * Shared recharts color theme for the dashboard widgets, mapped from our design
 * tokens. The TailGrids source used a blue `--color-primary-*` ramp; we remap
 * to First Bite's basil/brand greens so the widgets match the rest of the app.
 *
 * recharts needs raw color strings (not Tailwind classes), so these come from
 * `styles/tokens` — the same JS-token access the homepage charts use.
 */
export const chartTheme = {
  /** Primary series / single-series fills and strokes. */
  primary: colors['brand-bright'], // #0A9150
  primaryDark: colors['brand-active'], // #087443
  /**
   * Monochrome basil ramp (darkest → lightest) for small, cohesive series sets
   * — matches the Figma "Brand Basil" ramp (700 / 400 / 300 / 200) exactly.
   */
  series: [
    colors['brand-active'], // #087443 — Basil 700
    colors['basil-400'], // #39CE7E — Basil 400
    colors['basil-300'], // #72E3A3 — Basil 300
    colors['basil-200'], // #AAF0C4 — Basil 200
  ],
  /**
   * Distinct-hue categorical palette for multi-series charts (stacked bars,
   * many-slice donuts) where the monochrome ramp wouldn't differentiate. Leads
   * with brand green, then saturated Tailwind 500/600 hues — all chosen to hold
   * adequate contrast on a white surface (no pale yellows/limes). Cycles by index.
   */
  categorical: [
    colors['brand-bright'], // #0A9150 — brand green
    '#3B82F6', // blue-500
    '#F59E0B', // amber-500
    '#8B5CF6', // violet-500
    '#EF4444', // red-500
    '#0D9488', // teal-600
    '#EC4899', // pink-500
    '#EA580C', // orange-600
    '#6366F1', // indigo-500
    '#65A30D', // lime-600
  ],
  /** Gridlines — Figma Border/Secondary. */
  grid: colors['neutral-200'], // #E5E7EB
  /** Axis tick text — Figma Text/Secondary. */
  axis: colors['neutral-500'], // #6B7280
  /** Data-label text (dark, high contrast on the white card — above-bar labels). */
  label: colors['neutral-800'], // #1F2937
  /** Positive / negative deltas. */
  success: colors['success'], // #059669
  error: colors['error'], // #D43D51
} as const
